import { ERROR_MAX_QUERIES } from './../../../error/errorMessage';
const UNKNOWN = 'Unbekannter Fehler!';

export function getBefreiungError(err: any): string {
  if (!err || !err.status) {
    return UNKNOWN;
  }

  switch (err.status) {
      case 404: return 'Die Suche ergab keinen Treffer. <br/> <br/>Es liegt keine Zuzahlungsbefreiung vor.';
      case 429: return ERROR_MAX_QUERIES.title;

      default: return UNKNOWN;
  }
}



// WEBPACK FOOTER //
// ./src/app/befreiung/shared/services/befreiungError.ts